import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PortfolioService } from 'src/app/services/portfolio.service';

@Component({
  selector: 'app-portfolio',
  templateUrl: './portfolio.component.html',
  styleUrls: ['./portfolio.component.css']
})
export class PortfolioComponent implements OnInit {

  portfolioSpinnerDisplay: string = "inline";

  nothingInPortfolioAlertDisplay: string = "inline";
  portfolioDataToRender;

  faCaretUp = faCaretUp;
  faCaretDown = faCaretDown;

  buyTickerModal;
  buyCurrentPriceModal;
  buyQuantityModal: number = 0;
  buyTotalPriceModal: any = 0;
  buyButtonDisabledModal = true;
  buyCurrentPrice = 0;

  buyQuantityChange(event) {
    this.buyQuantityModal = Number.parseFloat(event.target.value);
    this.buyTotalPriceModal = (this.buyCurrentPrice * event.target.value).toFixed(2);
    console.log(this.buyTotalPriceModal);
    this.buyButtonDisabledModal = this.buyQuantityModal <= 0;
  }

  onBuyClicked(buycontent, portfolioDataItem) {
    this.buyTickerModal = portfolioDataItem["ticker"];
    this.buyCurrentPrice = portfolioDataItem["last"];
    this.buyButtonDisabledModal = this.buyQuantityModal <= 0;
    this.modalService
      .open(buycontent, { ariaLabelledBy: "modal-basic-title" })
      .result.then(
        result => {
          console.log("Buy clicked");

          let portfolio: any = localStorage.getItem("ritesht_portfolio")
          if (portfolio !== null && portfolio !== undefined) {
            portfolio = JSON.parse(portfolio);
            if (portfolio[portfolioDataItem["ticker"]])
              portfolio[portfolioDataItem["ticker"]] = [portfolio[portfolioDataItem["ticker"]][0], (portfolio[portfolioDataItem["ticker"]][1] ? Number.parseFloat(portfolio[portfolioDataItem["ticker"]][1]) : 0) + this.buyQuantityModal, portfolio[portfolioDataItem["ticker"]][2] + Number.parseFloat(this.buyTotalPriceModal)];
          }
          localStorage.setItem("ritesht_portfolio", JSON.stringify(portfolio));
          console.log(portfolio);

          this.buyQuantityModal = 0;
          this.buyTotalPriceModal = 0;
          this.buyButtonDisabledModal = true;

          this.loadPortfolioItems();
        },
        reason => {
          console.log("Buy not clicked");

          this.buyQuantityModal = 0;
          this.buyTotalPriceModal = 0;
          this.buyButtonDisabledModal = true;
        }
      );
  }

  sellTickerModal;
  sellCurrentPriceModal;
  sellQuantityModal: number = 0;
  sellQuantityLimitModal: number = 0;
  sellTotalPriceModal: any = 0;
  sellButtonDisabledModal = true;
  sellCurrentPrice = 0;

  sellQuantityChange(event) {
    this.sellQuantityModal = Number.parseFloat(event.target.value);
    this.sellTotalPriceModal = (this.sellCurrentPrice * event.target.value).toFixed(2);
    console.log(this.sellTotalPriceModal);
    this.sellButtonDisabledModal = (this.sellQuantityModal <= 0 || this.sellQuantityModal > this.sellQuantityLimitModal);
  }

  onSellClicked(sellcontent, portfolioDataItem) {
    this.sellTickerModal = portfolioDataItem["ticker"];
    this.sellCurrentPrice = portfolioDataItem["last"];
    this.sellQuantityLimitModal = portfolioDataItem["buyQuantity"];
    this.sellButtonDisabledModal = true;
    this.modalService
      .open(sellcontent, { ariaLabelledBy: "modal-basic-title" })
      .result.then(
        result => {
          console.log("Sell clicked");

          let portfolio: any = localStorage.getItem("ritesht_portfolio")
          if (portfolio !== null && portfolio !== undefined) {
            portfolio = JSON.parse(portfolio);
            if (portfolio[portfolioDataItem["ticker"]])
              portfolio[portfolioDataItem["ticker"]] = [portfolio[portfolioDataItem["ticker"]][0], (portfolio[portfolioDataItem["ticker"]][1] ? Number.parseFloat(portfolio[portfolioDataItem["ticker"]][1]) : 0) - this.sellQuantityModal, portfolio[portfolioDataItem["ticker"]][2] - Number.parseFloat(this.sellTotalPriceModal)];
          }
          if (portfolio[portfolioDataItem["ticker"]][1] === 0)
            delete portfolio[portfolioDataItem["ticker"]];

          localStorage.setItem("ritesht_portfolio", JSON.stringify(portfolio));
          console.log(portfolio);

          this.sellQuantityModal = 0;
          this.sellTotalPriceModal = 0;
          this.sellButtonDisabledModal = true;

          this.loadPortfolioItems();
        },
        reason => {
          console.log("Sell not clicked");

          this.sellQuantityModal = 0;
          this.sellTotalPriceModal = 0;
          this.sellButtonDisabledModal = true;
        }
      );
  }

  constructor(private portfolioService: PortfolioService, private modalService: NgbModal, private router: Router) { }

  loadPortfolioItems() {
    let portfolio: any = localStorage.getItem("ritesht_portfolio");
    if (portfolio !== null && portfolio !== undefined) {
      portfolio = JSON.parse(portfolio);

      if (portfolio === undefined || portfolio === null)
        portfolio = {};

      console.log(portfolio);

      if (Object.keys(portfolio).length > 0) {
        this.nothingInPortfolioAlertDisplay = "none";

        this.portfolioService.getPortfolioData(Object.keys(portfolio).join(",")).subscribe(portfolioData => {
          this.portfolioSpinnerDisplay = "none";
          this.portfolioDataToRender = portfolioData.map(r => {
            let p = {};
            for (const k in portfolio)
              if (k === r["ticker"]) {
                p = {
                  "stockName": portfolio[k][0],
                  "buyQuantity": portfolio[k][1],
                  "totalPrice": portfolio[k][2]
                };
                break;
              }
            let change = parseFloat((r["last"] - (p["totalPrice"] / p["buyQuantity"])).toFixed(2))
            console.log(change);
            if (change < 0)
              return { ...r, ...p, "color": "red", "faCaret": "faCaretDown" }
            else if (change > 0)
              return { ...r, ...p, "color": "green", "faCaret": "faCaretUp" }
            else
              return { ...r, ...p, "color": "black", "faCaret": "" }
          }).sort((a, b) => (a.ticker > b.ticker ? 1 : -1));
          console.log(this.portfolioDataToRender);
        });
      } else {
        this.portfolioDataToRender = [];
        this.portfolioSpinnerDisplay = "none";
        this.nothingInPortfolioAlertDisplay = "inline";
      }
    } else {
      this.portfolioDataToRender = [];
      this.portfolioSpinnerDisplay = "none";
      this.nothingInPortfolioAlertDisplay = "inline";
    }
  }

  ngOnInit(): void {
    this.loadPortfolioItems();
  }

  cardHeaderClicked(portfolioDataItem) {
    this.router.navigate(['/details/' + portfolioDataItem["ticker"]]);
  }
}
